var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 62,
    viewBox: "0 0 58 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multiple_Company",
    "data-name": "Multiple Company",
    transform: "translate(-1084 -661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(1084 694.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M-59.927,110.287h1.24V112.2l2.024,3.124v-1.8h1.35v2.157h-1.121l.7,1.078h.422v.652l2.024,3.125v-.542h1.35v2.157h-.3l4.89,7.548h.137V108.13H-61.324Zm10.013,0h1.349v2.157h-1.349Zm0,3.235h1.349v2.157h-1.349Zm0,3.235h1.349v2.157h-1.349Zm0,3.235h1.349v2.157h-1.349Zm0,3.235h1.349v2.157h-1.349Zm-3.374-12.939h1.35v2.157h-1.35Zm0,3.235h1.35v2.157h-1.35Zm0,3.235h1.35v2.157h-1.35Zm-3.374-6.47h1.35v2.157h-1.35Z",
    transform: "translate(61.386 -104.895)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M-52.356,122.148H-53.4v-1.615l-2.024-3.125v1.5h-1.35v-2.157h.928l-.7-1.078h-.229v-.353L-58.8,112.2v.243H-60.15v-2.157h.11l-1.4-2.157H-61.5V129.7h5.4v-2.157h3.374V129.7h5.262Zm-6.445,3.235H-60.15v-2.157H-58.8Zm0-3.235H-60.15v-2.157H-58.8Zm0-3.235H-60.15v-2.157H-58.8Zm0-3.235H-60.15v-2.157H-58.8Zm3.374,9.7h-1.35v-2.157h1.35Zm0-3.235h-1.35v-2.157h1.35Zm2.024,3.235v-2.157h1.35v2.157Z",
    transform: "translate(61.5 -104.895)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M-61.5,107.859v.1h.062Z",
    transform: "translate(61.5 -104.72)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M-47.328,106.165v-1.078H-61.5v.982l.062.1Z",
    transform: "translate(61.5 -102.93)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M-46.218,102.043H-57.69v1.078h11.472Z",
    transform: "translate(59.04 -100.965)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 8.773,
    height: 1.078,
    transform: "translate(2.699)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M-57.69,114.217v2.157h1.35v-.243l-1.24-1.914Z",
    transform: "translate(59.04 -108.826)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M-57.38,114.217l1.24,1.914v-1.914Z",
    transform: "translate(58.84 -108.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 1.35,
    height: 2.157,
    transform: "translate(4.724 5.391)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 1.35,
    height: 2.157,
    transform: "translate(8.098 5.391)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 5.391)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 1.35,
    height: 2.157,
    transform: "translate(1.35 8.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M-48.167,128.791h.229l-.229-.353Z",
    transform: "translate(52.89 -118.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M-46.817,123.348h-1.35v1.8l.229.353h1.121Z",
    transform: "translate(52.89 -114.722)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 1.35,
    height: 2.157,
    transform: "translate(8.098 8.626)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 8.626)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 1.35,
    height: 2.157,
    transform: "translate(1.35 11.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M-48.167,132.478v2.157h1.35v-1.5l-.422-.652Z",
    transform: "translate(52.89 -120.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M-45.549,132.478l.422.652v-.652Z",
    transform: "translate(51.201 -120.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 1.35,
    height: 2.157,
    transform: "translate(8.098 11.861)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 11.861)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 1.35,
    height: 2.157,
    transform: "translate(1.35 15.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 1.35,
    height: 2.157,
    transform: "translate(4.724 15.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M-37.293,141.609h-1.35v.542l1.046,1.615h.3Z",
    transform: "translate(46.741 -126.513)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M-38.643,144.753H-37.6l-1.046-1.615Z",
    transform: "translate(46.741 -127.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 15.096)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 1.35,
    height: 2.157,
    transform: "translate(1.35 18.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 1.35,
    height: 2.157,
    transform: "translate(4.724 18.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 1.35,
    height: 2.157,
    transform: "translate(8.098 18.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 3.374,
    height: 2.157,
    transform: "translate(5.399 22.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 18.331)",
    fill: "#6283a3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(1127.828 694.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659-2",
    "data-name": "Path 659",
    d: "M-59.927,110.287h1.24V112.2l2.024,3.124v-1.8h1.35v2.157h-1.121l.7,1.078h.422v.652l2.024,3.125v-.542h1.35v2.157h-.3l4.89,7.548h.137V108.13H-61.324Zm10.013,0h1.349v2.157h-1.349Zm0,3.235h1.349v2.157h-1.349Zm0,3.235h1.349v2.157h-1.349Zm0,3.235h1.349v2.157h-1.349Zm0,3.235h1.349v2.157h-1.349Zm-3.374-12.939h1.35v2.157h-1.35Zm0,3.235h1.35v2.157h-1.35Zm0,3.235h1.35v2.157h-1.35Zm-3.374-6.47h1.35v2.157h-1.35Z",
    transform: "translate(61.386 -104.895)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660-2",
    "data-name": "Path 660",
    d: "M-52.356,122.148H-53.4v-1.615l-2.024-3.125v1.5h-1.35v-2.157h.928l-.7-1.078h-.229v-.353L-58.8,112.2v.243H-60.15v-2.157h.11l-1.4-2.157H-61.5V129.7h5.4v-2.157h3.374V129.7h5.262Zm-6.445,3.235H-60.15v-2.157H-58.8Zm0-3.235H-60.15v-2.157H-58.8Zm0-3.235H-60.15v-2.157H-58.8Zm0-3.235H-60.15v-2.157H-58.8Zm3.374,9.7h-1.35v-2.157h1.35Zm0-3.235h-1.35v-2.157h1.35Zm2.024,3.235v-2.157h1.35v2.157Z",
    transform: "translate(61.5 -104.895)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661-2",
    "data-name": "Path 661",
    d: "M-61.5,107.859v.1h.062Z",
    transform: "translate(61.5 -104.72)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662-2",
    "data-name": "Path 662",
    d: "M-47.328,106.165v-1.078H-61.5v.982l.062.1Z",
    transform: "translate(61.5 -102.93)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663-2",
    "data-name": "Path 663",
    d: "M-46.218,102.043H-57.69v1.078h11.472Z",
    transform: "translate(59.04 -100.965)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146-2",
    "data-name": "Rectangle 146",
    width: 8.773,
    height: 1.078,
    transform: "translate(2.699)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664-2",
    "data-name": "Path 664",
    d: "M-57.69,114.217v2.157h1.35v-.243l-1.24-1.914Z",
    transform: "translate(59.04 -108.826)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665-2",
    "data-name": "Path 665",
    d: "M-57.38,114.217l1.24,1.914v-1.914Z",
    transform: "translate(58.84 -108.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147-2",
    "data-name": "Rectangle 147",
    width: 1.35,
    height: 2.157,
    transform: "translate(4.724 5.391)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148-2",
    "data-name": "Rectangle 148",
    width: 1.35,
    height: 2.157,
    transform: "translate(8.098 5.391)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149-2",
    "data-name": "Rectangle 149",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 5.391)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150-2",
    "data-name": "Rectangle 150",
    width: 1.35,
    height: 2.157,
    transform: "translate(1.35 8.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666-2",
    "data-name": "Path 666",
    d: "M-48.167,128.791h.229l-.229-.353Z",
    transform: "translate(52.89 -118.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667-2",
    "data-name": "Path 667",
    d: "M-46.817,123.348h-1.35v1.8l.229.353h1.121Z",
    transform: "translate(52.89 -114.722)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151-2",
    "data-name": "Rectangle 151",
    width: 1.35,
    height: 2.157,
    transform: "translate(8.098 8.626)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152-2",
    "data-name": "Rectangle 152",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 8.626)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153-2",
    "data-name": "Rectangle 153",
    width: 1.35,
    height: 2.157,
    transform: "translate(1.35 11.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668-2",
    "data-name": "Path 668",
    d: "M-48.167,132.478v2.157h1.35v-1.5l-.422-.652Z",
    transform: "translate(52.89 -120.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669-2",
    "data-name": "Path 669",
    d: "M-45.549,132.478l.422.652v-.652Z",
    transform: "translate(51.201 -120.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154-2",
    "data-name": "Rectangle 154",
    width: 1.35,
    height: 2.157,
    transform: "translate(8.098 11.861)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155-2",
    "data-name": "Rectangle 155",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 11.861)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156-2",
    "data-name": "Rectangle 156",
    width: 1.35,
    height: 2.157,
    transform: "translate(1.35 15.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157-2",
    "data-name": "Rectangle 157",
    width: 1.35,
    height: 2.157,
    transform: "translate(4.724 15.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670-2",
    "data-name": "Path 670",
    d: "M-37.293,141.609h-1.35v.542l1.046,1.615h.3Z",
    transform: "translate(46.741 -126.513)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671-2",
    "data-name": "Path 671",
    d: "M-38.643,144.753H-37.6l-1.046-1.615Z",
    transform: "translate(46.741 -127.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158-2",
    "data-name": "Rectangle 158",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 15.096)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159-2",
    "data-name": "Rectangle 159",
    width: 1.35,
    height: 2.157,
    transform: "translate(1.35 18.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160-2",
    "data-name": "Rectangle 160",
    width: 1.35,
    height: 2.157,
    transform: "translate(4.724 18.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161-2",
    "data-name": "Rectangle 161",
    width: 1.35,
    height: 2.157,
    transform: "translate(8.098 18.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162-2",
    "data-name": "Rectangle 162",
    width: 3.374,
    height: 2.157,
    transform: "translate(5.399 22.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163-2",
    "data-name": "Rectangle 163",
    width: 1.35,
    height: 2.157,
    transform: "translate(11.472 18.331)",
    fill: "#6283a3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(1095.737 661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659-3",
    "data-name": "Path 659",
    d: "M-57.831,113.521h3.1v4.785l5.061,7.811v-4.508H-46.3V127h-2.8l1.747,2.7H-46.3v1.63l5.061,7.812v-1.354h3.375v5.391h-.759l12.226,18.869h.343V108.13H-61.324Zm25.031,0h3.374v5.391H-32.8Zm0,8.087h3.374V127H-32.8Zm0,8.087h3.374v5.391H-32.8Zm0,8.087h3.374v5.391H-32.8Zm0,8.087h3.374v5.391H-32.8Zm-8.436-32.348h3.375v5.391h-3.375Zm0,8.087h3.375V127h-3.375Zm0,8.087h3.375v5.391h-3.375Zm-8.436-16.174H-46.3v5.391h-3.375Z",
    transform: "translate(61.48 -100.043)",
    fill: "#67839e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660-3",
    "data-name": "Path 660",
    d: "M-38.64,143.174h-2.616v-4.037l-5.061-7.812v3.762h-3.375V129.7h2.319l-1.747-2.7h-.572v-.883l-5.061-7.811v.607h-3.374v-5.391h.275l-3.493-5.391H-61.5v53.913H-48v-5.391h8.436v5.391h13.154Zm-16.112,8.087h-3.374v-5.391h3.374Zm0-8.087h-3.374v-5.391h3.374Zm0-8.087h-3.374V129.7h3.374Zm0-8.087h-3.374v-5.391h3.374Zm8.436,24.261h-3.375v-5.391h3.375Zm0-8.087h-3.375v-5.391h3.375Zm5.061,8.087v-5.391h3.375v5.391Z",
    transform: "translate(61.5 -100.043)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661-3",
    "data-name": "Path 661",
    d: "M-61.5,107.859v.241h.156Z",
    transform: "translate(61.5 -100.012)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662-3",
    "data-name": "Path 662",
    d: "M-26.071,107.783v-2.7H-61.5v2.455l.156.241Z",
    transform: "translate(61.5 -99.696)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663-3",
    "data-name": "Path 663",
    d: "M-29.01,102.043H-57.69v2.7h28.68Z",
    transform: "translate(61.065 -99.348)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146-3",
    "data-name": "Rectangle 146",
    width: 21.932,
    height: 2.696,
    transform: "translate(6.748)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664-3",
    "data-name": "Path 664",
    d: "M-57.69,114.217v5.391h3.374V119l-3.1-4.784Z",
    transform: "translate(61.065 -100.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665-3",
    "data-name": "Path 665",
    d: "M-57.38,114.217l3.1,4.784v-4.784Z",
    transform: "translate(61.029 -100.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147-3",
    "data-name": "Rectangle 147",
    width: 3.374,
    height: 5.391,
    transform: "translate(11.81 13.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148-3",
    "data-name": "Rectangle 148",
    width: 3.374,
    height: 5.391,
    transform: "translate(20.245 13.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149-3",
    "data-name": "Rectangle 149",
    width: 3.374,
    height: 5.391,
    transform: "translate(28.68 13.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150-3",
    "data-name": "Rectangle 150",
    width: 3.374,
    height: 5.391,
    transform: "translate(3.374 21.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666-3",
    "data-name": "Path 666",
    d: "M-48.167,129.321h.572l-.572-.882Z",
    transform: "translate(59.976 -102.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667-3",
    "data-name": "Path 667",
    d: "M-44.792,123.348h-3.374v4.509l.572.882h2.8Z",
    transform: "translate(59.976 -101.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151-3",
    "data-name": "Rectangle 151",
    width: 3.374,
    height: 5.391,
    transform: "translate(20.245 21.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152-3",
    "data-name": "Rectangle 152",
    width: 3.374,
    height: 5.391,
    transform: "translate(28.68 21.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153-3",
    "data-name": "Rectangle 153",
    width: 3.374,
    height: 5.391,
    transform: "translate(3.374 29.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668-3",
    "data-name": "Path 668",
    d: "M-48.167,132.478v5.391h3.374v-3.761l-1.056-1.63Z",
    transform: "translate(59.976 -102.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669-3",
    "data-name": "Path 669",
    d: "M-45.549,132.478l1.056,1.63v-1.63Z",
    transform: "translate(59.677 -102.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154-3",
    "data-name": "Rectangle 154",
    width: 3.374,
    height: 5.391,
    transform: "translate(20.245 29.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155-3",
    "data-name": "Rectangle 155",
    width: 3.374,
    height: 5.391,
    transform: "translate(28.68 29.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156-3",
    "data-name": "Rectangle 156",
    width: 3.374,
    height: 5.391,
    transform: "translate(3.374 37.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157-3",
    "data-name": "Rectangle 157",
    width: 3.374,
    height: 5.391,
    transform: "translate(11.81 37.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670-3",
    "data-name": "Path 670",
    d: "M-35.269,141.609h-3.374v1.355L-36.028,147h.759Z",
    transform: "translate(58.888 -103.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671-3",
    "data-name": "Path 671",
    d: "M-38.643,147.175h2.615l-2.615-4.037Z",
    transform: "translate(58.888 -104.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158-3",
    "data-name": "Rectangle 158",
    width: 3.374,
    height: 5.391,
    transform: "translate(28.68 37.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159-3",
    "data-name": "Rectangle 159",
    width: 3.374,
    height: 5.391,
    transform: "translate(3.374 45.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160-3",
    "data-name": "Rectangle 160",
    width: 3.374,
    height: 5.391,
    transform: "translate(11.81 45.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161-3",
    "data-name": "Rectangle 161",
    width: 3.374,
    height: 5.391,
    transform: "translate(20.245 45.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162-3",
    "data-name": "Rectangle 162",
    width: 8.435,
    height: 5.391,
    transform: "translate(13.497 56.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163-3",
    "data-name": "Rectangle 163",
    width: 3.374,
    height: 5.391,
    transform: "translate(28.68 45.826)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleCompany);
export default __webpack_public_path__ + "static/media/MultipleCompany.1d5d0b4dbdb60dc422ac491d540b50ff.svg";
export { ForwardRef as ReactComponent };